<template>
    <page title="Login">
        <div class="row">
            <div class="col-sm-8 offset-sm-2">
                <login-component label reset @loggedIn="$router.push({name: 'Home', params: {lang: language}})"></login-component>
            </div>
        </div>
    </page>
</template>

<script>
import Page from './utilities/Page'
import LoginComponent from './utilities/LoginComponent'
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  components: {Page, LoginComponent},
  computed: {
    ...mapGetters(['language']),
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue